module.exports = __webpack_public_path__ + "static/media/vi.8a178e2c.svg";